// extracted by mini-css-extract-plugin
export default {"container":"QnaView_container__IVvfD","limiter":"QnaView_limiter__QZDvS","head":"QnaView_head__VNQpS","label":"QnaView_label__jWV7Z","value":"QnaView_value__24iOj"};